module.exports = __webpack_public_path__ + "img/holiday.d4f7781b.svg";